 <template>
  <div id="privacy" class="page white">
    <el-container class="content-aside">
      <el-main class="cpl-main">
        <!-- Content -->
        <el-row :gutter="0" class="main-content-row hide-scrollbar">
          <div class="content-wrapper">

            <h2 class="font-bold text-xl">ARYA PRIVACY NOTICE</h2>

            <p class="pb-2 date-updated"><strong>Updated: 8 February 2024</strong></p>

            <h3 class="font-bold text-lg">Introduction</h3>

            <p class="pb-2">Your privacy
              is important to us at SpinetiX SA and our affiliates (<strong>SpinetiX</strong>). Our registered address
              is: Sonnenbergstrasse 9, 6052
              Hergiswil, Switzerland.</p>

            <p class="pb-2">This privacy
              notice details how SpinetiX processes the personal data we collect from you
              when you use our cloud services (SpinetiX ARYA). Our general privacy notice is
              available here <a class="underline text-[#0f447c]"
                href="https://www.spinetix.com/about-spinetix/legal/privacy-notice">https://www.spinetix.com/about-spinetix/legal/privacy-notice</a>
            </p>

            <p class="pb-2"><span>We may
                change our privacy notice from time to time. We will post any changes to our
                privacy notice here </span><span><a class="underline text-[#0f447c]"
                  href="https://arya.spinetix.cloud/privacy">https://arya.spinetix.cloud/privacy</a></span><span> with
                the effective date of the change. We encourage you to
                check back often for updates to this notice.</span></p>

            <p class="pb-2">If you have any questions or concerns
              about our use of your personal data, feel free to contact us at <a class="underline text-[#0f447c]"
                href="mailto:privacy@spinetix.com">privacy@spinetix.com</a> or by mail at Sonnenbergstrasse
              9, 6052 Hergiswil, Switzerland. </p>

            <h4 class="mt-4 font-bold"><b>Information we may collect about you</b></h4>

            <ul class="list-outside list-disc ml-2 pl-4">
              <li>
                <u>We may collect personal information directly from you:</u>

                <p clas="pl-6">when you register
                  online or place an order for any of our services, voluntarily use of our
                  support via chat or email, or otherwise liaise with us, we may collect from you
                  such information as first name, last name, email address, and if applicable, invoicing
                  and financial information, payment method, billing address, and VAT number.</p>
              </li>
              <li>
                <u>We may collect certain information
                  automatically:</u>
                <p class="pl-4">for
                  instance, when you use our cloud services or contact us through electronic
                  means. This information includes:</p>
                <ul class="list-outside list-disc ml-2 pl-4">
                  <li>Technical information, such as the Internet protocol (IP) address
                    used to connect your computer to the Internet, your login information, browser
                    type and version, time zone setting, and operating system;
                  </li>
                  <li>
                    Information about your use of our cloud services, such as
                    clickstream, page response times, errors, and interaction information (such as
                    scrolling, clicks, and mouse-overs);
                  </li>
                  <li>
                    Cookies. We may use cookies to distinguish you from other users
                    of our cloud services. This helps us to provide you with a good experience when
                    you use our cloud services and allows us to improve them. We provide detailed
                    information on the cookies we use below.
                  </li>
                </ul>
              </li>
              <li>
                <u>Information we receive from other sources:</u>
                <p class="pl-4">we may receive
                  information about you from various third parties, including our service
                  providers or SpinetiX’s distribution partners. You can find the list of our
                  distribution partners here - <a class="underline text-[#0f447c]"
                    href="https://www.spinetix.com/buy#where-to-buy">https://www.spinetix.com/buy#where-to-buy</a>.
                </p>
              </li>
            </ul>

            <h4 class="font-bold mt-4">Why we process information and legal bases
              to do so</h4>

            <p class="pb-2">We collect, use, and store personal
              information about you so that we can:</p>

            <ul class="list-outside list-disc ml-2 pl-4">
              <li>provide the cloud services you have ordered from us</li>
              <li>process your order and manage your account</li>
              <li>provide you with support and billing information</li>
              <li>send you our promotional offers</li>
              <li>prevent and investigate fraudulent activities</li>
              <li>operate our cloud services and business</li>
              <li>comply with legal obligations applicable to us</li>
              <li>for the purposes explained to you when we ask for your consent</li>
            </ul>

            <p class="pb-2">To process your personal information in the
              above context we may need to have specific grounds (also known as legal bases).
              Generally, we process your personal information for the performance of a
              contract with you or to take steps requested by you from us or based on the
              legitimate interests (e.g., to prevent or investigate fraudulent activities, or
              send you our promotional offers). We may process your personal information to
              comply with our legal obligations (e.g., to retain accounting records) or based
              on your consent.</p>

            <h4 class="mt-4 font-bold">When we share personal
              information and why</h4>

            <p class="pb-2"><span>We share or
                disclose personal information when necessary to provide you with our products,
                services, and events, and to provide updates and news on each of these. We also
                share or disclose personal information when necessary to conduct and administer
                our business operations.</span></p>

            <p class="pb-2"><u><span>Service
                  providers</span></u></p>

            <p class="pb-2"><span>We may share
                personal information with our third-party service providers to provide you our cloud
                services. If certain cookies are enabled on your device, then we may also share
                cookie-related information with related service providers.</span></p>

            <p class="pb-2"><span>We work with
                third party service providers for such purposes cloud hosting, payment
                processing, marketing automation, customer communication</span><span> and </span><span>relationship
                management. To review how these third-party service providers, use and process
                your personal information you should check their privacy notices and policies
                which we have detailed below.</span></p>

            <table class="my-4">
              <tbody>
                <tr>
                  <td>
                    <p align=center><strong><span>Solution</span></strong></p>

                  </td>
                  <td>

                    <p align=center><strong><span>Purpose</span></strong></p>

                  </td>
                  <td>

                    <p align=center><strong><span>Personal Information</span></strong></p>

                  </td>
                  <td>

                    <p align=center><strong><span>Provider</span></strong></p>

                  </td>
                  <td>

                    <p align=center><strong><span>Address</span></strong></p>

                  </td>
                  <td>

                    <p align=center><strong><span>Privacy Policy Link</span></strong></p>

                  </td>
                </tr>
                <tr>
                  <td>

                    <p class="pb-2"><span>AWS</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Application
                        hosting &amp; content delivery</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>IP
                        address, first name, last name, email, if applicable billing address or VAT
                        number</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Amazon
                        Data Services Ireland Limited</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>One
                        Burlington Plaza, Burlington Road, Dublin 4, Dublin, D04rh96, Ireland</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span><a class="underline text-[#0f447c]" href="https://aws.amazon.com/privacy"
                          target="_blank">Privacy Policy</a></span></p>

                  </td>
                </tr>
                <tr>
                  <td>

                    <p class="pb-2"><span>Google
                        Login</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Federated
                        identity service</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>IP
                        address, user ID</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Google
                        Inc.</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>600
                        Amphitheatre Parkway, Mountain View, CA 94043, USA</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span><a class="underline text-[#0f447c]" href="https://policies.google.com/privacy"
                          target="_blank">Privacy Policy</a></span></p>

                  </td>
                </tr>
                <tr>
                  <td>

                    <p class="pb-2"><span>Facebook
                        Login</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Federated
                        identity service</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>IP
                        address, user ID</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Facebook,
                        Inc</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>1 Hacker
                        Way, Menlo Park, CA 94025, USA</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span><a class="underline text-[#0f447c]"
                          href="https://www.facebook.com/about/privacy" target="_blank">Privacy Policy</a></span></p>

                  </td>
                </tr>
                <tr>
                  <td>

                    <p class="pb-2"><span>SIX
                        Payment Services</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Payment
                        processing</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>IP
                        address, user ID</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>SIX
                        Payment Services AG</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Hardturmstrasse
                        201, 8005 Zürich, Switzerland</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span><a class="underline text-[#0f447c]"
                          href="https://www.six-payment-services.com/en/services/legal/privacy-statement.html"
                          target="_blank"><span>Privacy Policy</span></a></span></p>

                  </td>
                </tr>
                <tr>
                  <td>

                    <p class="pb-2"><span>Datatrans</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Payment
                        processing</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>IP
                        address, user ID</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Datatrans
                        AG</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Kreuzbühlstrasse
                        26, 8008 Zürich, Switzerland</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span><a class="underline text-[#0f447c]"
                          href="https://www.datatrans.ch/en/privacy-policy" target="_blank"><span>Privacy
                            Policy</span></a></span></p>

                  </td>
                </tr>
                <tr>
                  <td>

                    <p class="pb-2"><span>Google
                        Analytics</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Marketing
                        campaigns, Analytics</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>IP
                        address</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Google
                        Inc.</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>600
                        Amphitheatre Parkway, Mountain View, CA 94043, USA</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span><a class="underline text-[#0f447c]" href="https://policies.google.com/privacy"
                          target="_blank">Privacy Policy</a></span></p>

                  </td>
                </tr>
                <tr>
                  <td>

                    <p class="pb-2"><span>Zendesk</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Customer
                        support</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>IP
                        address, first name, last name, email</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Zendesk
                        Inc.</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>989
                        Market Street, San Francisco, CA 94103, USA</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span><a class="underline text-[#0f447c]"
                          href="https://www.zendesk.com/company/agreements-and-terms/privacy-policy/"
                          target="_blank"><span>Privacy Policy</span></a></span></p>

                  </td>
                </tr>
                <tr>
                  <td>

                    <p class="pb-2"><span>Mixpanel</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Analytics</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>IP
                        address</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Mixpanel
                        Inc.</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>28th
                        Floor, San Francisco, CA 94111, USA</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span><a class="underline text-[#0f447c]"
                          href="https://mixpanel.com/legal/privacy-policy/" target="_blank">Privacy Policy</a></span>
                    </p>

                  </td>
                </tr>
                <tr>
                  <td>

                    <p class="pb-2"><span>Usercentrics</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Cookie consent</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>IP address, consent data, device data, geolocation</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Usercentrics GmbH</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span>Sendlinger Str. 7, 80331 München, DE</span></p>

                  </td>
                  <td>

                    <p class="pb-2"><span><a class="underline text-[#0f447c]" href="https://usercentrics.com/privacy-policy-cmp/"
                          target="_blank">Privacy Policy</a></span></p>

                  </td>
                </tr>
              </tbody>
            </table>

            <p class="pb-2"><u><span>Distribution
                  partners</span></u></p>

            <p class="pb-2"><span>If agreed by
                you, we will share your data with our partner companies so that they may offer
                you their products and services.</span><span> </span><span>You can find the list of our distribution
                partners here - </span><span><a class="underline text-[#0f447c]"
                  href="https://www.spinetix.com/buy#where-to-buy">https://www.spinetix.com/buy#where-to-buy</a></span><span>.</span>
            </p>

            <p class="pb-2"><u><span>Other third parties</span></u></p>

            <p class="pb-2"><span>We may share
                personal information with other third parties, where required, such as to
                comply with requests from governmental authorities when such disclosure is
                necessary according to applicable law.</span></p>

            <p class="pb-2"><span>When SpinetiX
                processes your order, it may send your data to, and also use the resulting
                information from, credit reference agencies to prevent fraudulent purchases.</span></p>

            <h4 class="mt-4 font-bold">Where we store, process,
              and transfer personal information</h4>

            <p class="pb-2"><span>We securely
                store your data at the AWS Cognito service, which is HIPAA eligible and PCI
                DSS, SOC, and ISO/IEC 27001, ISO/IEC 27017, ISO/IEC 27018, and ISO 9001
                compliant or as relevant, at other AWS storage services, which are ISO/IEC
                27001, ISO/IEC 27017, ISO/IEC 27018, and ISO 9001 compliant. All data is stored
                in the Frankfurt area in Germany (eu-central-1).</span></p>

            <p class="pb-2"><span>However,
                some personal information we collect may be transferred outside the country or
                territory where it was collected for further processing in accordance with this
                privacy notice</span><span> </span><span>to
                any country where we have facilities or in which we engage service providers. In
                this situation, we take steps to ensure your personal information is processed
                and transferred according to applicable law, such as GDPR and the Swiss New
                Federal Act on Data Protection (nFADP) of September 25th, 2020, and take
                measures to ensure your rights are adequately protected by technical and
                contractual means.</span></p>

            <h4 class="mt-4 font-bold">How long we store the personal information</h4>

            <p class="pb-2"><span>We keep
                personal information for the time necessary for us to complete the purposes for
                which it was collected, or as legally required (e.g. for accounting purposes).
                When we no longer need the personal information, it is deleted.</span></p>

            <h4 class="mt-4 font-bold">Your rights with respect to your personal information</h4>

            <p class="pb-2">You have certain right with respect
              to the personal information we hold on you:</p>

            <ul class="list-outside list-disc ml-2 pl-4">
              <li>Request a copy of the personal information we have about you</li>
              <li>Request us to correct or delete the personal information</li>
              <li>Request data portability</li>
              <li>Withdraw your consent to us processing your personal information</li>
              <li>Unsubscribe from a mailing list by using the unsubscribe button
                contained in each of our emails or as detailed below.</li>
            </ul>

            <p class="pb-2"><span>If you would
                like to exercise these rights or have any questions about this privacy notice,
                please contact us at&nbsp;</span><span><a class="underline text-[#0f447c]"
                  href="mailto:privacy@spinetix.com">privacy@spinetix.com</a></span><span>&nbsp;or
                write to us at our registered address: Sonnenbergstrasse 9, 6052 Hergiswil,
                Switzerland.</span></p>

            <p class="pb-2">Also,
              you have the right to lodge a complaint regarding our use of your personal
              information. Should you wish to report a complaint or if you feel that Our
              Company has not addressed your concern in a satisfactory manner, you may
              contact the Federal Data Protection and Information Commissioner (FDPIC), or
              your national data protection authority with regards to GDPR rights.</p>

            <p class="pb-2">For the
              FDPIC, please refer to <a class="underline text-[#0f447c]"
                href="https://www.edoeb.admin.ch/edoeb/en/home/deredoeb/kontakt.html">https://www.edoeb.admin.ch/edoeb/en/home/deredoeb/kontakt.html</a>.
            </p>

            <h4 class="mt-4 font-bold">Cookies</h4>

            <p class="pb-2"><span>A
                cookie is a small piece of data (text file) that a website when visited by a
                user asks your browser to store on your device in order to remember information
                about you, such as your language preference or login information. Those cookies
                are set by us and called first party cookies. We also use third party cookies
                which are cookies from a domain different than the domain of the website you
                are visiting for our promotional and marketing purposes.</span></p>

            <p class="pb-2"><span>More
                specifically, we use cookies and other similar tracking technologies for the
                following purposes:</span></p>

            <ul class="list-outside list-disc ml-2 pl-4">
              <li>Assisting you in navigation and
                language preference;</li>

              <li>Assisting in registration, login, and
                your ability to obtain support and provide feedback;</li>

              <li>Analysing your use of our products,
                services, or apps;</li>

              <li>Assisting with our promotional and
                marketing purposes.</li>

            </ul>

            <p class="pb-2"><span>You
                can find the detailed list of the cookies we use and their description here </span><span><a
                  class="underline text-[#0f447c]" href="https://arya.spinetix.cloud/cookie-notice">Cookies
                  Notice</a></span><span>. </span></p>

            <p class="pb-2"><span>You
                can manage your cookie preferences here:</span></p>

            <p class="pb-2"><button
                class="el-button cstm-btn-gradient width-125 el-button--default privacy-settings-btn"
                @click="changeCookiesPreference()">Change your cookie preferences</button></p>

            <h4 class="mt-4 font-bold">Customer Data</h4>

            <p class="pb-2"><span>This privacy
                notice does not apply to the information (content) that you upload to our cloud
                services. The storage and processing of such information is subject to our
                separate agreement with you.</span></p>

            <h4 class="mt-4 font-bold">Third-party websites</h4>

            <p class="pb-2"><span>Our cloud
                services may contain links to other websites. Our privacy notice applies only
                to our cloud services, so if you click on a link to another website, you should
                read their privacy notice.</span></p>

          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script src="./privacy.js"></script>
<style lang="scss" src="./privacy.scss"></style>
